module.exports = __webpack_public_path__ + "img/cognni_logo_captions.fc332232.svg";